var AwUploadErrorEnum;
(function (AwUploadErrorEnum) {
    AwUploadErrorEnum["SomethingWentWrong"] = "SomethingWentWrong";
    AwUploadErrorEnum["UnsupportedFileType"] = "UnsupportedFileType";
    AwUploadErrorEnum["MaxFileSizeExceed"] = "MaxFileSizeExceed";
    AwUploadErrorEnum["Timeout"] = "Timeout";
})(AwUploadErrorEnum || (AwUploadErrorEnum = {}));
var AwUploadErrorEnum$1 = AwUploadErrorEnum;

var AwUploaderStatus;
(function (AwUploaderStatus) {
    AwUploaderStatus["InQueue"] = "inQueue";
    AwUploaderStatus["Processing"] = "processing";
    AwUploaderStatus["Pending"] = "pending";
    AwUploaderStatus["Complete"] = "complete";
    AwUploaderStatus["Error"] = "error";
    AwUploaderStatus["VirusChecking"] = "virusChecking";
    AwUploaderStatus["VirusCheckingFailed"] = "virusCheckingFailed";
})(AwUploaderStatus || (AwUploaderStatus = {}));
var AwUploaderEventType;
(function (AwUploaderEventType) {
    AwUploaderEventType["Error"] = "error";
    AwUploaderEventType["Processing"] = "processing";
    AwUploaderEventType["UploadProgress"] = "uploadprogress";
    AwUploaderEventType["Success"] = "success";
})(AwUploaderEventType || (AwUploaderEventType = {}));
var AwUploaderError;
(function (AwUploaderError) {
    AwUploaderError["ServerError"] = "serverError";
    AwUploaderError["UnsupportedFileType"] = "unsupportedFileType";
    AwUploaderError["MaxFileSizeExceed"] = "maxFileSizeExceed";
    AwUploaderError["MaxFilesExceeded"] = "maxFilesExceed";
    AwUploaderError["Timeout"] = "timeout";
    AwUploaderError["UnexpectedError"] = "unexpectedError";
})(AwUploaderError || (AwUploaderError = {}));

var Country;
(function (Country) {
    Country["Afghanistan"] = "AF";
    Country["AlandIslands"] = "AX";
    Country["Albania"] = "AL";
    Country["Algeria"] = "DZ";
    Country["AmericanSamoa"] = "AS";
    Country["Andorra"] = "AD";
    Country["Angola"] = "AO";
    Country["Anguilla"] = "AI";
    Country["Antarctica"] = "AQ";
    Country["AntiguaAndBarbuda"] = "AG";
    Country["Argentina"] = "AR";
    Country["Armenia"] = "AM";
    Country["Aruba"] = "AW";
    Country["Australia"] = "AU";
    Country["Austria"] = "AT";
    Country["Azerbaijan"] = "AZ";
    Country["Bahamas"] = "BS";
    Country["Bahrain"] = "BH";
    Country["Bangladesh"] = "BD";
    Country["Barbados"] = "BB";
    Country["Belarus"] = "BY";
    Country["Belgium"] = "BE";
    Country["Belize"] = "BZ";
    Country["Benin"] = "BJ";
    Country["Bermuda"] = "BM";
    Country["Bhutan"] = "BT";
    Country["Bolivia"] = "BO";
    Country["BonaireSintEustatiusSaba"] = "BQ";
    Country["BosniaAndHerzegovina"] = "BA";
    Country["Botswana"] = "BW";
    Country["BouvetIsland"] = "BV";
    Country["Brazil"] = "BR";
    Country["BritishIndianOceanTerritory"] = "IO";
    Country["BruneiDarussalam"] = "BN";
    Country["Bulgaria"] = "BG";
    Country["BurkinaFaso"] = "BF";
    Country["Burundi"] = "BI";
    Country["Cambodia"] = "KH";
    Country["Cameroon"] = "CM";
    Country["Canada"] = "CA";
    Country["CapeVerde"] = "CV";
    Country["CaymanIslands"] = "KY";
    Country["CentralAfricanRepublic"] = "CF";
    Country["Chad"] = "TD";
    Country["Chile"] = "CL";
    Country["China"] = "CN";
    Country["ChristmasIsland"] = "CX";
    Country["CocosKeelingIslands"] = "CC";
    Country["Colombia"] = "CO";
    Country["Comoros"] = "KM";
    Country["Congo"] = "CG";
    Country["CongoDemocraticRepublic"] = "CD";
    Country["CookIslands"] = "CK";
    Country["CostaRica"] = "CR";
    Country["CoteDIvoire"] = "CI";
    Country["Croatia"] = "HR";
    Country["Cuba"] = "CU";
    Country["Cura\u00E7ao"] = "CW";
    Country["Cyprus"] = "CY";
    Country["CzechRepublic"] = "CZ";
    Country["Denmark"] = "DK";
    Country["Djibouti"] = "DJ";
    Country["Dominica"] = "DM";
    Country["DominicanRepublic"] = "DO";
    Country["Ecuador"] = "EC";
    Country["Egypt"] = "EG";
    Country["ElSalvador"] = "SV";
    Country["EquatorialGuinea"] = "GQ";
    Country["Eritrea"] = "ER";
    Country["Estonia"] = "EE";
    Country["Ethiopia"] = "ET";
    Country["FalklandIslands"] = "FK";
    Country["FaroeIslands"] = "FO";
    Country["Fiji"] = "FJ";
    Country["Finland"] = "FI";
    Country["France"] = "FR";
    Country["FrenchGuiana"] = "GF";
    Country["FrenchPolynesia"] = "PF";
    Country["FrenchSouthernTerritories"] = "TF";
    Country["Gabon"] = "GA";
    Country["Gambia"] = "GM";
    Country["Georgia"] = "GE";
    Country["Germany"] = "DE";
    Country["Ghana"] = "GH";
    Country["Gibraltar"] = "GI";
    Country["Greece"] = "GR";
    Country["Greenland"] = "GL";
    Country["Grenada"] = "GD";
    Country["Guadeloupe"] = "GP";
    Country["Guam"] = "GU";
    Country["Guatemala"] = "GT";
    Country["Guernsey"] = "GG";
    Country["Guinea"] = "GN";
    Country["GuineaBissau"] = "GW";
    Country["Guyana"] = "GY";
    Country["Haiti"] = "HT";
    Country["HeardIslandMcdonaldIslands"] = "HM";
    Country["HolySeeVaticanCityState"] = "VA";
    Country["Honduras"] = "HN";
    Country["HongKong"] = "HK";
    Country["Hungary"] = "HU";
    Country["Iceland"] = "IS";
    Country["India"] = "IN";
    Country["Indonesia"] = "ID";
    Country["Iran"] = "IR";
    Country["Iraq"] = "IQ";
    Country["Ireland"] = "IE";
    Country["IsleOfMan"] = "IM";
    Country["Israel"] = "IL";
    Country["Italy"] = "IT";
    Country["Jamaica"] = "JM";
    Country["Japan"] = "JP";
    Country["Jersey"] = "JE";
    Country["Jordan"] = "JO";
    Country["Kazakhstan"] = "KZ";
    Country["Kenya"] = "KE";
    Country["Kiribati"] = "KI";
    Country["Korea"] = "KR";
    Country["KoreaDemocraticPeoplesRepublic"] = "KP";
    Country["Kuwait"] = "KW";
    Country["Kyrgyzstan"] = "KG";
    Country["LaoPeoplesDemocraticRepublic"] = "LA";
    Country["Latvia"] = "LV";
    Country["Lebanon"] = "LB";
    Country["Lesotho"] = "LS";
    Country["Liberia"] = "LR";
    Country["LibyanArabJamahiriya"] = "LY";
    Country["Liechtenstein"] = "LI";
    Country["Lithuania"] = "LT";
    Country["Luxembourg"] = "LU";
    Country["Macao"] = "MO";
    Country["Macedonia"] = "MK";
    Country["Madagascar"] = "MG";
    Country["Malawi"] = "MW";
    Country["Malaysia"] = "MY";
    Country["Maldives"] = "MV";
    Country["Mali"] = "ML";
    Country["Malta"] = "MT";
    Country["MarshallIslands"] = "MH";
    Country["Martinique"] = "MQ";
    Country["Mauritania"] = "MR";
    Country["Mauritius"] = "MU";
    Country["Mayotte"] = "YT";
    Country["Mexico"] = "MX";
    Country["Micronesia"] = "FM";
    Country["Moldova"] = "MD";
    Country["Monaco"] = "MC";
    Country["Mongolia"] = "MN";
    Country["Montenegro"] = "ME";
    Country["Montserrat"] = "MS";
    Country["Morocco"] = "MA";
    Country["Mozambique"] = "MZ";
    Country["Myanmar"] = "MM";
    Country["Namibia"] = "NA";
    Country["Nauru"] = "NR";
    Country["Nepal"] = "NP";
    Country["Netherlands"] = "NL";
    Country["NewCaledonia"] = "NC";
    Country["NewZealand"] = "NZ";
    Country["Nicaragua"] = "NI";
    Country["Niger"] = "NE";
    Country["Nigeria"] = "NG";
    Country["Niue"] = "NU";
    Country["NorfolkIsland"] = "NF";
    Country["NorthernMarianaIslands"] = "MP";
    Country["Norway"] = "NO";
    Country["Oman"] = "OM";
    Country["Pakistan"] = "PK";
    Country["Palau"] = "PW";
    Country["PalestinianTerritory"] = "PS";
    Country["Panama"] = "PA";
    Country["PapuaNewGuinea"] = "PG";
    Country["Paraguay"] = "PY";
    Country["Peru"] = "PE";
    Country["Philippines"] = "PH";
    Country["Pitcairn"] = "PN";
    Country["Poland"] = "PL";
    Country["Portugal"] = "PT";
    Country["PuertoRico"] = "PR";
    Country["Qatar"] = "QA";
    Country["Reunion"] = "RE";
    Country["Romania"] = "RO";
    Country["RussianFederation"] = "RU";
    Country["Rwanda"] = "RW";
    Country["SaintBarthelemy"] = "BL";
    Country["SaintHelena"] = "SH";
    Country["SaintKittsAndNevis"] = "KN";
    Country["SaintLucia"] = "LC";
    Country["SaintMartin"] = "MF";
    Country["SaintPierreAndMiquelon"] = "PM";
    Country["SaintVincentAndGrenadines"] = "VC";
    Country["Samoa"] = "WS";
    Country["SanMarino"] = "SM";
    Country["SaoTomeAndPrincipe"] = "ST";
    Country["SaudiArabia"] = "SA";
    Country["Senegal"] = "SN";
    Country["Serbia"] = "RS";
    Country["Seychelles"] = "SC";
    Country["SierraLeone"] = "SL";
    Country["Singapore"] = "SG";
    Country["SintMaarten"] = "SX";
    Country["Slovakia"] = "SK";
    Country["Slovenia"] = "SI";
    Country["SolomonIslands"] = "SB";
    Country["Somalia"] = "SO";
    Country["SouthAfrica"] = "ZA";
    Country["SouthGeorgiaAndSandwichIsl"] = "GS";
    Country["SouthSudan"] = "SS";
    Country["Spain"] = "ES";
    Country["SriLanka"] = "LK";
    Country["Sudan"] = "SD";
    Country["Suriname"] = "SR";
    Country["SvalbardAndJanMayen"] = "SJ";
    Country["Swaziland"] = "SZ";
    Country["Sweden"] = "SE";
    Country["Switzerland"] = "CH";
    Country["SyrianArabRepublic"] = "SY";
    Country["Taiwan"] = "TW";
    Country["Tajikistan"] = "TJ";
    Country["Tanzania"] = "TZ";
    Country["Thailand"] = "TH";
    Country["TimorLeste"] = "TL";
    Country["Togo"] = "TG";
    Country["Tokelau"] = "TK";
    Country["Tonga"] = "TO";
    Country["TrinidadAndTobago"] = "TT";
    Country["Tunisia"] = "TN";
    Country["Turkey"] = "TR";
    Country["Turkmenistan"] = "TM";
    Country["TurksAndCaicosIslands"] = "TC";
    Country["Tuvalu"] = "TV";
    Country["Uganda"] = "UG";
    Country["Ukraine"] = "UA";
    Country["UnitedArabEmirates"] = "AE";
    Country["UnitedKingdom"] = "GB";
    Country["UnitedStates"] = "US";
    Country["UnitedStatesOutlyingIslands"] = "UM";
    Country["Uruguay"] = "UY";
    Country["Uzbekistan"] = "UZ";
    Country["Vanuatu"] = "VU";
    Country["Venezuela"] = "VE";
    Country["Vietnam"] = "VN";
    Country["VirginIslandsBritish"] = "VG";
    Country["VirginIslandsUS"] = "VI";
    Country["WallisAndFutuna"] = "WF";
    Country["WesternSahara"] = "EH";
    Country["Yemen"] = "YE";
    Country["Zambia"] = "ZM";
    Country["Zimbabwe"] = "ZW";
})(Country || (Country = {}));

var LAYOUT_TYPES;
(function (LAYOUT_TYPES) {
    LAYOUT_TYPES["A"] = "A";
    LAYOUT_TYPES["B"] = "B";
    LAYOUT_TYPES["C"] = "C";
    LAYOUT_TYPES["D"] = "D";
    LAYOUT_TYPES["E"] = "E";
})(LAYOUT_TYPES || (LAYOUT_TYPES = {}));
var LAYOUT_TYPES$1 = LAYOUT_TYPES;

var ListTagsEnum;
(function (ListTagsEnum) {
    ListTagsEnum["ul"] = "ul";
    ListTagsEnum["div"] = "div";
})(ListTagsEnum || (ListTagsEnum = {}));
var ListTagsEnum$1 = ListTagsEnum;

var TIME_FORMATS;
(function (TIME_FORMATS) {
    TIME_FORMATS["AMPM"] = "ampm";
    TIME_FORMATS["MILITARY"] = "military";
})(TIME_FORMATS || (TIME_FORMATS = {}));
var TIME_FORMATS$1 = TIME_FORMATS;

var ThemeEnum;
(function (ThemeEnum) {
    ThemeEnum["Default"] = "";
    ThemeEnum["Dark"] = "theme-dark";
    ThemeEnum["Light"] = "theme-light";
})(ThemeEnum || (ThemeEnum = {}));
var ThemeEnum$1 = ThemeEnum;

var ThemeLight;
(function (ThemeLight) {
    ThemeLight["Neutral1"] = "#ffffff";
    ThemeLight["Neutral2"] = "#f7f7f7";
    ThemeLight["Neutral3"] = "#f0f1f2";
    ThemeLight["Neutral4"] = "#e8eaed";
    ThemeLight["Neutral5"] = "#141414";
    ThemeLight["Neutral6"] = "#bec3cc";
    ThemeLight["Neutral7"] = "#5b6b7b";
    ThemeLight["Hue1"] = "#1774cc";
    ThemeLight["Hue2"] = "#7863e0";
    ThemeLight["Hue3"] = "#c32dc3";
    ThemeLight["Hue4"] = "#a34903";
    ThemeLight["Hue5"] = "#007a06";
    ThemeLight["Hue6"] = "#00857a";
    ThemeLight["Hue7"] = "#0e62b8";
    ThemeLight["Hue8"] = "#594bb0";
    ThemeLight["Hue9"] = "#af20af";
    ThemeLight["Hue10"] = "#c01316";
    ThemeLight["Hue11"] = "#a34903";
    ThemeLight["Hue12"] = "#00635b";
    ThemeLight["Hue13"] = "#396070";
    ThemeLight["Primary"] = "#1774cc";
    ThemeLight["Primary2"] = "#0e62b8";
    ThemeLight["Tertiary"] = "#1774cc";
    ThemeLight["Success"] = "#008906";
    ThemeLight["Success2"] = "#007a06";
    ThemeLight["Warning"] = "#ba5b03";
    ThemeLight["Warning2"] = "#a34903";
    ThemeLight["Danger"] = "#d93b3d";
    ThemeLight["Danger2"] = "#c01316";
    ThemeLight["White"] = "#ffffff";
    ThemeLight["Black"] = " #000";
})(ThemeLight || (ThemeLight = {}));
var ThemeDark;
(function (ThemeDark) {
    ThemeDark["Neutral1"] = "#1a1f24";
    ThemeDark["Neutral2"] = "#232a30";
    ThemeDark["Neutral3"] = "#141414";
    ThemeDark["Neutral4"] = "#313a42";
    ThemeDark["Neutral5"] = "#ffffff";
    ThemeDark["Neutral6"] = "#5b6b7b";
    ThemeDark["Neutral7"] = "#bec3cc";
    ThemeDark["Hue1"] = "#1774cc";
    ThemeDark["Hue2"] = "#7863e0";
    ThemeDark["Hue3"] = "#c32dc3";
    ThemeDark["Hue4"] = "#ef9c23";
    ThemeDark["Hue5"] = "#39d627";
    ThemeDark["Hue6"] = "#00857a";
    ThemeDark["Hue7"] = "#46aff2";
    ThemeDark["Hue8"] = "#ad9fff";
    ThemeDark["Hue9"] = "#f26df2";
    ThemeDark["Hue10"] = "#ff787a";
    ThemeDark["Hue11"] = "#fcd54e";
    ThemeDark["Hue12"] = "#00e5d2";
    ThemeDark["Hue13"] = "#396070";
    ThemeDark["Primary"] = "#1774cc";
    ThemeDark["Primary2"] = "#46aff2";
    ThemeDark["tertiary"] = "#1774cc";
    ThemeDark["Success"] = "#008906";
    ThemeDark["Success2"] = "#39d627";
    ThemeDark["Warning"] = "#ba5b03";
    ThemeDark["Warning2"] = "#ef9c23";
    ThemeDark["Danger"] = "#d93b3d";
    ThemeDark["Danger2"] = "#ff787a";
    ThemeDark["White"] = "#fff";
    ThemeDark["Black"] = "#000";
})(ThemeDark || (ThemeDark = {}));

var EventCodeEnum;
(function (EventCodeEnum) {
    EventCodeEnum["Space"] = "Space";
    EventCodeEnum["Enter"] = "Enter";
    EventCodeEnum["Backspace"] = "Backspace";
})(EventCodeEnum || (EventCodeEnum = {}));
var EventCodeEnum$1 = EventCodeEnum;

var PHONE_NUMBER_FORMAT;
(function (PHONE_NUMBER_FORMAT) {
    PHONE_NUMBER_FORMAT[PHONE_NUMBER_FORMAT["E164"] = 0] = "E164";
    PHONE_NUMBER_FORMAT[PHONE_NUMBER_FORMAT["INTERNATIONAL"] = 1] = "INTERNATIONAL";
    PHONE_NUMBER_FORMAT[PHONE_NUMBER_FORMAT["NATIONAL"] = 2] = "NATIONAL";
    PHONE_NUMBER_FORMAT[PHONE_NUMBER_FORMAT["RFC3966"] = 3] = "RFC3966";
})(PHONE_NUMBER_FORMAT || (PHONE_NUMBER_FORMAT = {}));
var PHONE_NUMBER_TYPE;
(function (PHONE_NUMBER_TYPE) {
    PHONE_NUMBER_TYPE[PHONE_NUMBER_TYPE["FIXED_LINE"] = 0] = "FIXED_LINE";
    PHONE_NUMBER_TYPE[PHONE_NUMBER_TYPE["MOBILE"] = 1] = "MOBILE";
    PHONE_NUMBER_TYPE[PHONE_NUMBER_TYPE["FIXED_LINE_OR_MOBILE"] = 2] = "FIXED_LINE_OR_MOBILE";
    PHONE_NUMBER_TYPE[PHONE_NUMBER_TYPE["TOLL_FREE"] = 3] = "TOLL_FREE";
    PHONE_NUMBER_TYPE[PHONE_NUMBER_TYPE["PREMIUM_RATE"] = 4] = "PREMIUM_RATE";
    PHONE_NUMBER_TYPE[PHONE_NUMBER_TYPE["SHARED_COST"] = 5] = "SHARED_COST";
    PHONE_NUMBER_TYPE[PHONE_NUMBER_TYPE["VOIP"] = 6] = "VOIP";
    PHONE_NUMBER_TYPE[PHONE_NUMBER_TYPE["PERSONAL_NUMBER"] = 7] = "PERSONAL_NUMBER";
    PHONE_NUMBER_TYPE[PHONE_NUMBER_TYPE["PAGER"] = 8] = "PAGER";
    PHONE_NUMBER_TYPE[PHONE_NUMBER_TYPE["UAN"] = 9] = "UAN";
    PHONE_NUMBER_TYPE[PHONE_NUMBER_TYPE["VOICEMAIL"] = 10] = "VOICEMAIL";
    PHONE_NUMBER_TYPE[PHONE_NUMBER_TYPE["UNKNOWN"] = -1] = "UNKNOWN";
})(PHONE_NUMBER_TYPE || (PHONE_NUMBER_TYPE = {}));
var PHONE_NUMBER_VALIDATION_ERROR;
(function (PHONE_NUMBER_VALIDATION_ERROR) {
    PHONE_NUMBER_VALIDATION_ERROR[PHONE_NUMBER_VALIDATION_ERROR["IS_POSSIBLE"] = 0] = "IS_POSSIBLE";
    PHONE_NUMBER_VALIDATION_ERROR[PHONE_NUMBER_VALIDATION_ERROR["INVALID_COUNTRY_CODE"] = 1] = "INVALID_COUNTRY_CODE";
    PHONE_NUMBER_VALIDATION_ERROR[PHONE_NUMBER_VALIDATION_ERROR["TOO_SHORT"] = 2] = "TOO_SHORT";
    PHONE_NUMBER_VALIDATION_ERROR[PHONE_NUMBER_VALIDATION_ERROR["TOO_LONG"] = 3] = "TOO_LONG";
    PHONE_NUMBER_VALIDATION_ERROR[PHONE_NUMBER_VALIDATION_ERROR["IS_POSSIBLE_LOCAL_ONLY"] = 4] = "IS_POSSIBLE_LOCAL_ONLY";
    PHONE_NUMBER_VALIDATION_ERROR[PHONE_NUMBER_VALIDATION_ERROR["INVALID_LENGTH"] = 5] = "INVALID_LENGTH";
})(PHONE_NUMBER_VALIDATION_ERROR || (PHONE_NUMBER_VALIDATION_ERROR = {}));

var AwBreadcrumbTarget;
(function (AwBreadcrumbTarget) {
    AwBreadcrumbTarget["Self"] = "_self";
    AwBreadcrumbTarget["Blank"] = "_blank";
    AwBreadcrumbTarget["Top"] = "_top";
    AwBreadcrumbTarget["Parent"] = "_parent";
})(AwBreadcrumbTarget || (AwBreadcrumbTarget = {}));

export { AwBreadcrumbTarget, AwUploadErrorEnum$1 as AwUploadErrorEnum, AwUploaderError, AwUploaderEventType, AwUploaderStatus, Country, EventCodeEnum$1 as EventCodeEnum, LAYOUT_TYPES$1 as LAYOUT_TYPES, ListTagsEnum$1 as ListTagsEnum, PHONE_NUMBER_FORMAT, PHONE_NUMBER_TYPE, PHONE_NUMBER_VALIDATION_ERROR, TIME_FORMATS$1 as TIME_FORMATS, ThemeDark, ThemeEnum$1 as ThemeEnum, ThemeLight };

//# sourceMappingURL=aw-ads-components-src-enums.js.map